// src/utils/base.ts
function dictionaryToArray(dict) {
  return Object.keys(dict).map((key) => dict[key]);
}
var getTypographyStyle = (theme, key, includeKey = true) => {
  return `
    ${includeKey ? `${key} {` : ""}
      color: ${theme.typography[key].color};
      font-family: ${theme.typography[key].fontFamily};
      font-weight:  ${theme.typography[key].fontWeight};
      font-size:  ${theme.typography[key].fontSize};
      line-height:  ${theme.typography[key].lineHeight};
      margin:  ${theme.typography[key].margin};
    ${includeKey ? "}" : ""}
  `;
};
var getThemeObjectTokens = (themeObject, properties = Object.keys(themeObject)) => {
  return properties.reduce((acc, attribute) => {
    acc[attribute] = themeObject[attribute].value.toString();
    return acc;
  }, {});
};

export {
  dictionaryToArray,
  getTypographyStyle,
  getThemeObjectTokens
};
//# sourceMappingURL=chunk-BPL7EIXS.js.map